import { proviewSlice } from './slice';
import { createSelector } from '@reduxjs/toolkit';
const selectProviewState = createSelector((state) => state, (state) => state[proviewSlice.name]);
export const selectProviewStart = createSelector(selectProviewState, (state) => state.shouldStartProview);
export const selectProviewStop = createSelector(selectProviewState, (state) => state.shouldStopProview);
export const selectProviewSessionUUID = createSelector(selectProviewState, (state) => state.getSessionUUID);
export const selectProviewInitStatus = createSelector(selectProviewState, (state) => state.sessionInitStatus);
export const selectIsProviewReady = createSelector(selectProviewState, (state) => state.isProviewReady);
export const selectIsSessionActive = createSelector(selectProviewState, (state) => state.isSessionActive);
export const selectIsProviewV8Failed = createSelector(selectProviewState, (state) => state.isProviewV8Failed);
